<div *ngIf="navigationEnabled">

  <lib-nav-provider-bar></lib-nav-provider-bar>

  <div id="header" class="darwinHeader">

    <header class="awin">
      <lib-nav-header-bar></lib-nav-header-bar>
      <lib-nav-menu></lib-nav-menu>
      <lib-nav-breadcrumbs></lib-nav-breadcrumbs>
    </header>

  </div>

</div>
